import {ImageContent} from "../../../common/types/post.types";

function Image(props: {data: ImageContent}) {
  return (
    <div className={'image-content'}>
      <img style={{width: props.data.width ?? ''}} src={props.data.url} alt={props.data.caption} />
      <div>{props.data.caption}</div>
    </div>
  )
}

export default Image;
